<template>
    <div class="nav_top">
      <div v-if="navType === 1" class="flex_center">
        <a v-if="hasBack" href="javascript:history.go(-1)" class="btn_back flex_center">
          <img class="icon-normal" src="@/assets/icon/icon_back.png"/>
        </a>
        <p class="title">{{navTitle}}</p>
      </div>
      <div v-if="navType === 3" class="flex_end">
        <router-link class="btn_link flex_row_center" to="/index">
          <p class="btn_content">다음에 할게요</p><img class="arrow_light" src="@/assets/icon/arrow.png"/>
        </router-link>
      </div>
      <div v-if="navType === 4" class="flex_center">
        <left-menu :show="leftMenuShow"></left-menu>
        <a v-if="hasBack" @click="leftMenu" href="javascript:void(0);" class="btn_back flex_center">
          <img class="icon-normal" src="@/assets/icon/icon_menu.png"/>
        </a>
        <img class="icon_logo" src="@/assets/icon/logo.png"/>
      </div>

    </div>
</template>

<script>

  import leftMenu from '../components/leftMenu'

  export default {
    name: 'navTop',
    components: {leftMenu},
    data(){
      return {
        leftMenuShow:false
      }
    },
    props: {
      navType: {
        type: Number,
        default: 1
      },
      hasBack: {
        type: Boolean,
        default: true
      },
      navTitle: {
        type: String,
        default: ''
      },
      navIcon: {
        type: String,
        default: ''
      }
    }
    ,methods:{
      leftMenu(){
        this.leftMenuShow = true;
      }
    }

  }
</script>

<style scoped>
  .icon_logo{
    width: 1.85rem;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/navTop.vue